import { Button } from "react-bootstrap";

export const PremiumToast = ({ setPopupSubscribe }) => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <span style={{ marginBottom: '0.5rem' }}>
      Please upgrade to our premium plan to unlock unlimited followers on your business page.
    </span>
    <Button
      onClick={() => { setPopupSubscribe(true) }}
      style={{
        backgroundColor: '#6148a1',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: 'bold',
      }}
    >
      Upgrade
    </Button>
  </div>
);